import { render, staticRenderFns } from "./ButtonCost.vue?vue&type=template&id=5dc9b4cf&scoped=true&"
import script from "./ButtonCost.vue?vue&type=script&lang=ts&"
export * from "./ButtonCost.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonCost.vue?vue&type=style&index=0&id=5dc9b4cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9b4cf",
  null
  
)

export default component.exports